/**
 * Skeleton Component
 * A loading placeholder component with pulse animation.
 * @packageDocumentation
 */

import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

/**
 * Skeleton loading placeholder component.
 *
 * @param { HTMLAttributes<HTMLDivElement> } props Component props.
 * @returns { JSX.Element } The skeleton element.
 */
const Skeleton = ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('animate-pulse rounded-md bg-primary/10', className)} {...props} />
);

export { Skeleton };
